import { useEffect, useRef, useState } from 'react'
import cx from 'classnames'

import { Spin } from 'common/Spin/Spin'
import { GenericEmbed } from 'types'
import Styles from '../Prompt.module.scss'
import InvalidEmbed from './InvalidEmbed'

export interface Props {
  stagedEmbed: GenericEmbed | undefined
  isValidEmbedUrl: boolean
  errorMessage?: string
}

const Preview = ({ stagedEmbed, isValidEmbedUrl, errorMessage }: Props) => {
  const [loading, setLoading] = useState(true)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  const handleOnLoad = () => {
    if (iframeRef.current) {
      const iframeBody = iframeRef.current.contentDocument?.body

      if (iframeBody?.firstChild) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ;(iframeBody!.firstChild as HTMLElement).style.maxWidth = 'none'
      }
    }

    setLoading(false)
  }

  useEffect(() => {
    if (!!stagedEmbed?.html && !!stagedEmbed.url) {
      setLoading(false)
    }
  }, [stagedEmbed])

  return (
    <div className={Styles.previewContainer}>
      {!isValidEmbedUrl && <InvalidEmbed errorMessage={errorMessage} />}

      {(() => {
        if (isValidEmbedUrl && !stagedEmbed?.html) {
          return <InvalidEmbed heading="We cannot render a preview for this embed" />
        } else if (loading && isValidEmbedUrl && stagedEmbed) {
          return <Spin />
        }
      })()}

      {isValidEmbedUrl && stagedEmbed && (
        <iframe
          ref={iframeRef}
          srcDoc={stagedEmbed.html as string}
          title="Embed"
          className={cx({ [Styles.hide]: loading })}
          onLoad={handleOnLoad}
        />
      )}
    </div>
  )
}

export default Preview
